import { type FunctionComponent, type ReactNode } from 'react';
import { Helmet } from 'react-helmet-async';
import { type Maybe, type ContentPromotionImageShade } from '../../../__generated__/graphql-client-types';
import { getBackgroundStyle } from '../promo-helpers/promo-banner.helpers';

export type BannerImageProps = {
	className?: string;
	backgroundUrl: string;
	imageShade: Maybe<ContentPromotionImageShade>;
	children: ReactNode;
	preload?: boolean;
};

export const BannerImage: FunctionComponent<BannerImageProps> = ({
	className = '',
	backgroundUrl,
	imageShade,
	children,
	preload = true
}) => {
	return (
		<>
			{preload && (
				<Helmet>
					{/* TODO: replace fetchpriority spread with fetchPriority once we're on React 19+ */}
					<link rel="preload" as="image" href={backgroundUrl} data-testid="banner-image-link" {...{ fetchpriority: 'high' }} />
				</Helmet>
			)}
			<div className={className} style={getBackgroundStyle(imageShade, backgroundUrl)} data-testid="banner-image">
				{children}
			</div>
		</>
	);
};
